import React from 'react';
import { NavArrowLeft } from 'iconoir-react';
import { useTranslation } from 'react-i18next';

/** Card shell aligned with sign-in: 608px, border, off-white */
export const REGISTER_CARD_CLASS =
  'flex w-full max-w-[608px] flex-col gap-6 rounded-lg border border-[#E2E8F0] bg-[#F9FAFB] p-6';

export const ACTION_COL_CLASS = 'mx-auto flex w-full max-w-[400px] flex-col gap-4';

export const primaryCtaClassName =
  'w-full rounded-md border border-[#6ECFCF] bg-[#6ECFCF] px-4 py-3 text-sm font-semibold text-gray-900 transition-colors hover:brightness-95 focus:outline-none focus:ring-2 focus:ring-[#6ECFCF] focus:ring-offset-2';

export const outlineCtaClassName =
  'flex w-full items-center justify-center gap-2 rounded-md border border-[#939393] bg-white px-4 py-3 text-sm font-medium text-gray-900 shadow-sm transition-colors hover:bg-gray-50';

export const labelClassAuth = 'text-[#131315]';

export function RegisterStepFooter({ step }: { step: 1 | 2 | 3 | 4 }) {
  const { t } = useTranslation('auth');
  return (
    <p className="text-center text-sm text-gray-500">{t('register.step_footer', { step })}</p>
  );
}

export function RegisterBackButton({ onBack }: { onBack: () => void }) {
  const { t } = useTranslation('auth');
  return (
    <div className="mb-2 flex w-full max-w-full justify-start">
      <button
        type="button"
        onClick={onBack}
        className="inline-flex items-center justify-center rounded-lg border-0 bg-transparent p-1.5 text-gray-900 hover:bg-gray-100/80"
        aria-label={t('shared.back_aria')}
      >
        <NavArrowLeft className="h-5 w-5" />
      </button>
    </div>
  );
}
